import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FilterUrlService } from '../../services/filter-url.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { TagsService } from '../../services/tags.service';
import * as moment from 'moment';

@Component({
  selector: 'admin-table',
  templateUrl: './admin-table.component.html',
})

export class AdminTableComponent implements OnInit {
  @Input() data:any;
  @Input() settings:any;
  @Output() onShowUpdateForm = new EventEmitter<number>();
  @Output() onShowViewForm = new EventEmitter<number>();
  @Output() onShowFinalizarForm = new EventEmitter<any>();
  @Output() onAgregarCaja = new EventEmitter<any>();
  @Output() onQuitarCaja = new EventEmitter<any>();
  @Output() onDeleteItem = new EventEmitter<any>();
  @Output() onFilterItems = new EventEmitter<any>();
  @Output() onShowEditOrder = new EventEmitter<any>();
  @Output() onShowDetailGroup = new EventEmitter<any>();
  @Output() onSendOrder = new EventEmitter<any>();
  @Output() onApproveOrder = new EventEmitter<any>();
  @Output() onOpenPDF = new EventEmitter<any>();

  public bloquearCamara:boolean;


  url:string = "";
  filter = {
    sort:{ },
    values: { }
  };

  constructor(private _tagsService:TagsService, private url_service:FilterUrlService, private _localeService: BsLocaleService) {
    this.url_service.changeFilters("");
    this.bloquearCamara = false;
  }

  ngOnInit() {


    this._localeService.use('es');
    let columns:any = this.settings['columns'];
    //console.log("COLUMNAS RECIBIDAS:  ", columns);
    /*iniciando los filtros respecto a las settings.columns que se reciben*/
    for(let key in columns){
      //console.log("Nombre Columna: ",key);
      /*añadiendo un filtro si trae por defecto el visible true*/
      if (columns.hasOwnProperty(key) && columns[key].ignored != true) {
        //console.log("KEY: ",key);
        /*agregando un sort con el nombre de la columna*/
        if(columns[key]['filter']['default'] == 'desc' && columns[key]['filter']['default'] != 'undefined'){
          //console.log("si Entró");
          this.filter['sort'][key] = "desc";
        }
        else{
          this.filter['sort'][key] = (columns[key]['sort'] === 'undefined')?columns[key]['sort']['default']:"asc";
        }


        /*seteando el valor de la columna en vacio ('')*/
        this.filter['values'][key]='';

        //console.log("this.filter Parcial: ", this.filter);
      }
    }
    //console.log("FILTRO FINAL; ",this.filter);
    /*comprobando permisos*/
    let roles = JSON.parse(localStorage.getItem('roles'));
    for(let rol of roles){
      if(rol.attributes.name === 'Camara'){
        this.bloquearCamara = true;
      }
    }
  }

  transform_to_array(data:any){
    //console.log("DATA: ", data);
    if(data!=undefined){
      data = JSON.parse(data)
      let response = [];
      for (var key in data ) {
          if (data.hasOwnProperty(key)) {
            response.push( {"id":key, "value":data[key]} );
          }
      }
      return response;
    }

  }

  transform_to_array2(data:any){
    if(data!=undefined){
      let data2 = JSON.parse(data);
      let items = [];
      for(var key in data2){
        if (data.hasOwnProperty(key)) {
          items.push( {"id":key, "value":data2[key]} );
        }

      }

      return items;
      //console.log("items transformados: ",items);

    }
  }

  /*cambia el valor de la flecha del campo a asc o desc dependiendo del valor que tenga key = columna, val = (asc o desc)*/
  public sortFilter(key, val){
    if(val == 'asc'){
      this.filter['sort'][key] = "desc";
    }else{
      this.filter['sort'][key] = "asc";
    }
    this.sortDataRequest();
  }

  /*actualiza el valor de una columna al presionar la tecla enter*/
  public dataFilter(key, event, es_fecha=false){
    //console.log("EVENT: ", event);
    if(es_fecha){
      let fecha = moment(event).format("YYYY-MM-DD");
      /*se verifica que la fecha sea válida*/
      if(moment(event).isValid()){
        this.filter['values'][key] = fecha;
      }else{
        this.filter['values'][key] = "";
      }
    }else{
      this.filter['values'][key] = event.target.value;
    }
    this.sortDataRequest();
  }

  public sortDataRequest(){
    this.url = '?sort=';
    /*recorriendo los filter.sort (nombre de columnas)*/
    for(let key in this.filter['sort']){
      if(this.settings['columns'][key]['type'] == 'text' ){
        if(this.filter['sort'][key]=='asc'){
          /*ordenar de manera ascendente*/
          this.url+='++'+key;
        }else{
          /*ordenar de manera descendente*/
          this.url+='--'+key;
        }
      }else{
        /*this.filter.sort.columna (equivalente a lo que esta en el if) */
        if(this.filter['sort'][key]=='asc'){
          this.url+='+'+key;
        }else{this
          this.url+='-'+key;
        }
      }
      this.url+=',';
    }

    //console.log("this.url antes del slice: ", this.url);
    this.url = this.url.slice(0,-1);
    //console.log("this.url despues del slice: ", this.url);

    /*recorriendo los valores de filter.values por cada columna*/
    for(let key in this.filter['values']){

      if(this.filter['values'][key] != '' ){

        if(this.settings['columns'][key]['type'] == 'text' || this.settings['columns'][key]['type'] == 'date'){

          if(this.settings['columns'][key]['type'] == 'date'){
            this.url+='&'+key+'=><'+ this.filter['values'][key];
          }
          else{
                  if(this.settings['columns'][key]['type'] == 'obj'){

                      if(this.settings['columns'][key]['filter']['id_type'] == 'text'){
                        this.url+='&'+key+'=><'+ this.filter['values'][key];
                      }
                      else{
                        this.url+='&'+key+'='+this.filter['values'][key];
                      }
                  }
                  else{
                    this.url+='&'+key+'=><'+this.filter['values'][key];
                  }
          }

        }
        else{
          this.url+='&'+key+'='+this.filter['values'][key];
        }
      }

    }
    //console.log("url nueva: ", this.url);
    this.url_service.changeFilters(this.url);
    this.onFilterItems.emit(this.url);
  }

  /*changeFormatDate(date:string){
    let arr = date.split('-');
    return `${arr[2]}-${arr[1]}-${arr[0]}`;
  }*/

/**
 * Emite un evento hacia el padre, el cual debe desplegar el formulario
 * para editar la fila de la tabla.
 * @param index indice de la fila dentro de la tabla
 */
  public showEditForm(index:number):void{
    this.onShowUpdateForm.emit(index);
  }

  /**
   * Emite un evento hacia el padre, el cual debe desplegar el formulario
   * para editar la fila de la tabla.
   * @param index indice de la fila dentro de la tabla
   */
    public showEditOrder(id:number):void{
      //console.log("ID TABLA: ", id);
      this.onShowEditOrder.emit(id);
    }

/**
 * Funcion que permite ver detalles de la fila.
 * @param index indice de la fila dentro de la tabla
 */
 public showViewForm(index:number):void{
   this.onShowViewForm.emit(index);
 }

 /**
  * Funcion que abre el modal para ver detalles del grupo.
  * @param item grupo seleccionado
  */
  public showGroupDetail(item:any,index:number):void{
    //console.log("Item:", item);
    item.index = index;
    this.onShowDetailGroup.emit(item);
  }

 /**
  * Funcion que permite ver Finalizar una Orden de Producción.
  * @param index indice de la fila dentro de la tabla
  */
  public showFinalizar(op:any,index:number){
    this.onShowFinalizarForm.emit({op,index});
  }

 /**
  * Funcion que permite ver detalles de la fila.
  * @param index indice de la fila dentro de la tabla
  */
  public onFilterItem():void{
    this.onFilterItems.emit();
  }

/**
 * Permite borrar una fila de la tabla. Emite un evento al padre con un objeto data.
 * @param url   Url hacia donde se realiza el DELETE.
 * @param index Indice de la fila a borrar.
 */
  public deleteItem(url, index):void{
    let data = {
      "url": url.links ? url.links.self : url,
      "index": index
    };
    this.onDeleteItem.emit(data);
  }

/**
 * Obtiene el valor de la clave foranea
 * @param  item punto de partida
 * @param  path ruta hacia el valor
 * @return      valor del
 */
  getValue(item:any, path){
    //console.log("Item Lote ", item);
    //console.log("Ruta ",path);
    if(path == 'id'){
      return (item.id);
    }
    else{
      return this.descend(item, path);
    }
  }

  /**
   * agrega una caja a la orden de salida
   * @param  item punto de partida
   * @param  path ruta hacia el valor
   * @return      valor del
   */
    agregarCaja(item:any, index:number){
      //console.log("Item Lote ", item);
      //console.log("Ruta ",path);
      this.onAgregarCaja.emit({item,index});
      //console.log('item agregar: ', item);
    }

    /**
     * agrega una caja a la orden de salida
     * @param  item punto de partida
     * @param  index posicion
     * @return      valor del
     */
      sendOrder(item:any, index:number){
        //console.log("Item Lote ", item);
        //console.log("Ruta ",path);
        this.onSendOrder.emit({item,index});
        //console.log('item agregar: ', item);
      }

      /**
       * agrega una caja a la orden de salida
       * @param  item punto de partida
       * @param  index posicion
       * @return      valor del
       */
        approveOrder(item:any, index:number){
          //console.log("Item Lote ", item);
          //console.log("Ruta ",path);
          this.onApproveOrder.emit({item,index});
          //console.log('item agregar: ', item);
        }

        /**
         * abre una pestaña para el PDF
         * @param  item objeto
         * @param  index posicion
         * @return      valor del
         */
          openPdf(item:any){
            //console.log("Item Lote ", item);
            //console.log("Ruta ",path);
            this.onOpenPDF.emit(item);
            //console.log('item agregar: ', item);
          }

    /**
     * quita una caja a la orden de salida
     * @param  item punto de partida
     * @param  path ruta hacia el valor
     * @return      valor del
     */
      quitarCaja(item:any, index:number){
        //console.log("Item Lote ", item);
        //console.log("Ruta ",path);
        this.onQuitarCaja.emit({item,index});
        //console.log('item quitar: ', item);
      }

/**
 * Recorre el arreglo json para obtener un valor de la clave foranea
 * @param  object objeto desde donde se analiza
 * @param  sub    ruta a recorrer
 * @return        valor deseado.
 */
  descend(object, sub) {
    var handle = object,
    stack = sub.split('.'),
    history = [],
    peek;

    while (handle[stack[0]]) {
      if (peek) {
        history.push(peek);
      }
      peek = stack.shift();
      handle = handle[peek];
    }

    if (stack.length > 0) {
      history.push(peek);
      handle = "";
      //console.log("Error, ruta erronea, no se puede llegar a '" + stack.join('.') + "' desde '" + history.join('.') + "'.");
    }

    return handle;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/shared/admin-table.component.ts